import React from 'react';

export const NyxtLogo = ({ size = 40, className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`logo-animate ${className}`}
    >
      {/* Gradient definitions */}
      <defs>
        <linearGradient id="techGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#D97757" />
          <stop offset="50%" stopColor="#E8956F" />
          <stop offset="100%" stopColor="#D97757" />
        </linearGradient>
        <linearGradient id="glowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4A5D4E" />
          <stop offset="100%" stopColor="#6B8E72" />
        </linearGradient>
      </defs>
      
      {/* Outer hexagonal ring */}
      <path 
        d="M50 8 L85 27 L85 73 L50 92 L15 73 L15 27 Z" 
        fill="none"
        stroke="url(#techGradient)"
        strokeWidth="3"
      />
      
      {/* Inner geometric N shape */}
      <path 
        d="M30 72 L30 28 L38 28 L38 55 L62 28 L70 28 L70 72 L62 72 L62 45 L38 72 Z" 
        fill="url(#techGradient)"
      />
      
      {/* Tech circuit dots */}
      <circle cx="50" cy="14" r="4" fill="url(#glowGradient)" />
      <circle cx="85" cy="50" r="3" fill="url(#glowGradient)" />
      <circle cx="15" cy="50" r="3" fill="url(#glowGradient)" />
      
      {/* Center pulse dot */}
      <circle cx="50" cy="50" r="5" fill="#D97757" opacity="0.6">
        <animate attributeName="r" values="4;6;4" dur="2s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.6;0.9;0.6" dur="2s" repeatCount="indefinite" />
      </circle>
      
      {/* Corner accents */}
      <path d="M50 8 L56 14 L50 20 L44 14 Z" fill="url(#glowGradient)" opacity="0.8" />
    </svg>
  );
};

export const NyxtLogoText = ({ className = '' }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <NyxtLogo size={36} />
      <span 
        className="text-xl font-medium tracking-tight"
        style={{ fontFamily: 'Cabinet Grotesk, sans-serif', color: '#1A1D1A' }}
      >
        NYXT AI
      </span>
    </div>
  );
};

export default NyxtLogo;
